import type { Application, ApplicationState, Notification } from '@/types';

const PATCHABLE_NOTIFICATION_TYPES = new Set<Notification['type']>([
  'screening_completed',
  'candidate_hired',
  'candidate_rejected',
  'candidate_withdrawn',
  'offer_declined',
  'pipeline_error',
]);

export function notificationSupportsListPatch(type: Notification['type']): boolean {
  return PATCHABLE_NOTIFICATION_TYPES.has(type);
}

export function hasListPatchPayload(payload: Notification['payload']): boolean {
  return (
    Boolean(payload.positionId && payload.applicationId)
    && Boolean(payload.applicationState && payload.applicationUpdatedAt)
  );
}

/**
 * Builds a list patch from an enriched notification payload (Phase 1.5 B2).
 * Returns null when payload lacks list fields — caller should upsertOne.
 */
export function patchApplicationFromNotification(
  notification: Notification,
  companyId: string,
): Application | null {
  const { payload, type } = notification;
  if (!notificationSupportsListPatch(type)) return null;
  if (!hasListPatchPayload(payload)) return null;

  const positionId = payload.positionId!;
  const applicationId = payload.applicationId!;

  return {
    id: applicationId,
    companyId,
    positionId,
    positionTitle: '',
    postingId: '',
    channel: 'Other',
    candidateFirstName: ' ',
    candidateLastName: '',
    candidateEmail: 'patch@local',
    state: payload.applicationState as ApplicationState,
    aiScore: payload.aiScore,
    screeningReports: [],
    interviews: [],
    history: [],
    appliedAt: payload.applicationUpdatedAt!,
    updatedAt: payload.applicationUpdatedAt!,
    hasScheduledInterview: payload.hasScheduledInterview,
    archived: payload.archived,
  };
}
